export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4761.a17fcd81.jpg";